export default {
  /**
   * Tất cả
   */
  All: 0,

  /**
   * Chưa đọc
   */
  Unread: 1,

  /**
   * Đã đọc
   */
  Read: 2,
};
